import React from 'react';
import Bar from '@splunk/dashboard-visualizations/Bar';

export default () => (
    <Bar
        options={{}}
        encoding={{
            x: 'primary.component',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'component', groupby_rank: '0' }, { name: 'count' }],
                    columns: [
                        ['foo', 'bar', 'foobar'],
                        ['1556', '8904', '2327'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
